import type { FeatureItem } from '@aibees/shared/definition';

interface RowWithOrder extends FeatureItem {
  _order: number;
}

interface GroupAcc {
  name: string;
  minOrder: number;
  items: RowWithOrder[];
}

// Support feature is at section_order 10 in the new schema; the synthesized
// sibling row sits a fraction higher so it groups visually with Chat Support
// (before White Label at 11 and GTM Calls at 12).
const SUPPORT_BASE_ORDER = 10;

/**
 * The catalog ships only one Support row per plan — code SUPPORT carries the
 * specific tier ("Chat" or "Private Slack Channel") via values_per_plan.
 * The Figma inclusion list shows the full ladder (Chat Support → Private
 * Slack Channel) with non-applicable tiers disabled. This expander
 * synthesizes the missing sibling row.
 *
 * - Plan resolved to "Chat Support" → add disabled "Private Slack Channel"
 * - Plan resolved to "Private Slack Channel" → add enabled "Chat Support"
 *   (higher tier inherits lower-tier perks)
 */
export function expandSupportLadder(group: GroupAcc): void {
  const hasChat = group.items.some((i) => i.title === 'Chat Support');
  const hasSlack = group.items.some((i) => i.title === 'Private Slack Channel');

  if (hasChat && !hasSlack) {
    group.items.push({
      id: 'SUPPORT_PRIVATE_SLACK',
      title: 'Private Slack Channel',
      disabled: true,
      _order: SUPPORT_BASE_ORDER + 0.5,
    });
  } else if (hasSlack && !hasChat) {
    group.items.push({
      id: 'SUPPORT_CHAT',
      title: 'Chat Support',
      disabled: false,
      _order: SUPPORT_BASE_ORDER - 0.5,
    });
  }
}

export type { GroupAcc, RowWithOrder };
